import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../../Services/axiosCommon";
import { useFormik } from "formik";
import { useToast } from "../../../../Components/Others/ToastServices";
import {
  useLocation,
  useParams,
  useNavigate,
} from "react-router-dom";
import * as yup from "yup";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import { BackButton } from "../../../../Components/Utils/Buttons";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import NewCommonDynamicForm from "../../../../Components/Utils/NewCommonDynamicForm";
import { GetAccess, GetRole } from "../../../../Components/Utils/roles";
import EditIcon from "../../../../Components/Icons/Edit";
import NuDate from "../../../../Components/Utils/NuDate";

function FormOpen() {
  const navigate = useNavigate();
  const [signOne, setSignOne] = useState(null);
  const [signTwo, setSignTwo] = useState(null);
  const [filesList, setFileList] = useState([]);
  const [removeSignOne, setRemoveSignOne] = useState("");
  const [removeSignTwo, setRemoveSignTwo] = useState("");
  const { scheduleViewId } = useParams();
  const [editModeIndex, setEditModeIndex] = useState(null);
  const location = useLocation();

  const form = location.state?.form;

  const toast = useToast();
  const [expandedIndex, setExpandedIndex] = useState(null);

  const [allFormValues, setAllFormValues] = useState([]);
  const [allForm, setAllForm] = useState([]);
  const [allValue, setAllValue] = useState([]);
  const [isSubmittted, setisSubmittted] = useState(false);
  const [fileRemoveList, setFileRemoveList] = useState([]);

  const [showNavigationConfirm, setShowNavigationConfirm] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [isClosingForm, setIsClosingForm] = useState(false);

  const originalNavigate = useRef(navigate);

  const [forms, setForms] = useState([]);

  // Move formatDateTime outside of useEffect
  const formatDateTime = (dateTime) => {
    if (!dateTime) return 'N/A';

    const date = new Date(dateTime);

    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '-');

    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    return `${formattedDate}, ${formattedTime}`;
  };

  useEffect(() => {
    if (scheduleViewId) {
      fetchAllForm(scheduleViewId);
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);

  useEffect(() => {
    const handleNavigation = (to, options) => {
      if (editModeIndex === scheduleViewId) {
        setPendingNavigation({ to, options });
        setShowNavigationConfirm(true);
        return false; 
      }
      return originalNavigate.current(to, options);
    };

    navigate.replace = handleNavigation;
  }, [editModeIndex, scheduleViewId, navigate]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (editModeIndex === scheduleViewId) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
        return e.returnValue;
      }
    };

    const handleSidebarClick = (e) => {
      const link = e.target.closest("a[href]");
      if (link && editModeIndex === scheduleViewId) {
        e.preventDefault();
        setPendingNavigation(link.getAttribute("href"));
        setShowNavigationConfirm(true);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("click", handleSidebarClick);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("click", handleSidebarClick);
    };
  }, [editModeIndex, scheduleViewId]);

  const fetchTasks = async (value) => {
    try {
      const response = await axiosInstance.get(`/schedules/forms/${value}`);
      const Data = response.data?.data;
      setisSubmittted(response?.data?.isSubmitted === false);
      setAllFormValues(Data);
      setForms(response.data?.data || []);
      checkAllSubmitted();
      checkOtpEnable();
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const [formId, setFormId] = useState(null);

  const fetchAllForm = async (value) => {
    setFormId(value);
    try {
      const formResponse = await axiosInstance.get(
        `/schedules/form-fields/${value}`
      );
      setAllForm(formResponse.data?.data);
      let TempArray = [];
      let tempFormData = formResponse.data?.data?.titles || [];
      tempFormData?.forEach((item) => {
        item?.fields?.forEach((field) => {
          let ValueInSide = {
            id: field?.id,
            field_type: field?.field_type,
            field_label: field?.field_label,
            value: field?.value,
          };
          TempArray.push(ValueInSide);
        });
      });
      setAllValue(TempArray);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const [showErrorFeild, setShowErrorFeild] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: yup.object({}),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      let ValuesForForm = {
        isSubmitted: true,
        values: allValue,
        filesToRemove: [],
        oldSign1: removeSignOne || "",
        oldSign2: removeSignTwo || "",
      };
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(ValuesForForm));
      filesList &&
        filesList.map((item) => {
          formData.append("attachments", item);
        });
      signOne &&
        formData.append(
          "signature1",
          signOne,
          `signature1-${formId}-${new Date().toISOString()}.png`
        );
      signTwo &&
        formData.append(
          "signature2",
          signTwo,
          `signature2-${formId}-${new Date().toISOString()}.png`
        );
      axiosInstance
        .put(`/schedules/form-submition/${formId}`, formData)
        .then((res) => {
          if (res.data?.status === true) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Created Successfully.",
            });
            CloseEditForm(formId);
          } else {
            toast.open({
              type: "error",
              message: "Error",
              description: res.data?.msg || "Network error.",
            });
            setShowErrorFeild(true);
            setErrorMessage(res.data?.data || "Network error.");
          }
        })
        .catch((error) => {
          toast.open({
            type: "error",
            message: "Error",
            description: error?.response?.data?.msg || "Network error.",
          });
        });
    },
  });

  function SaveFormData() {
    let ValuesForForm = {
      isSubmitted: false,
      values: allValue,
      filesToRemove: [],
      oldSign1: removeSignOne || "",
      oldSign2: removeSignTwo || "",
    };
    let formData = new FormData();
    formData.append("json_data", JSON.stringify(ValuesForForm));
    filesList &&
      filesList.map((item) => {
        formData.append("attachments", item);
      });
    signOne &&
      formData.append(
        "signature1",
        signOne,
        `signature1-${formId}-${new Date().toISOString()}.png`
      );
    signTwo &&
      formData.append(
        "signature2",
        signTwo,
        `signature2-${formId}-${new Date().toISOString()}.png`
      );

    axiosInstance
      .put(`/schedules/form-submition/${formId}`, formData)
      .then((res) => {
        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
          CloseEditForm(formId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      })
      .catch((error) => {
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
      });
  }

  async function CloseEditForm(formId) {
    try {
      const res = await axiosInstance.put(`/schedules/close-form/${formId}`);
      if (res?.data?.status) {
        setEditModeIndex(null);
        fetchTasks(formId);
        return true;
      } else {
        toast.open({
          type: "error",
          message: "Error",
          description: res.data?.msg || "Network error.",
        });
        return false;
      }
    } catch (error) {
      toast.open({
        type: "error",
        message: "Error",
        description: error?.response?.data?.msg || "Network error.",
      });
      return false;
    }
  }

  async function OpenEditForm(formId, workingUser) {
    if (workingUser) {
      CloseEditForm(formId);
    } else {
      try {
        const res = await axiosInstance.put(`/schedules/open-form/${formId}`);
        if (res?.data?.status) {
          fetchTasks(formId);
          setEditModeIndex(formId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      } catch (error) {
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
      }
    }
  }

  const handleNavigation = (targetPath) => {
    if (editModeIndex === scheduleViewId) {
      setPendingNavigation(targetPath);
      setShowNavigationConfirm(true);
    } else {
      navigate(targetPath);
    }
  };

  const confirmNavigation = async () => {
    setIsClosingForm(true);
    const success = await CloseEditForm(scheduleViewId);
    setIsClosingForm(false);

    if (success) {
      setShowNavigationConfirm(false);
      if (pendingNavigation !== null) {
        if (typeof pendingNavigation === "object" && pendingNavigation.to) {
          navigate(pendingNavigation.to, pendingNavigation.options);
        } else {
          navigate(pendingNavigation);
        }
      }
    }
  };

  const cancelNavigation = () => {
    setShowNavigationConfirm(false);
    setPendingNavigation(null);
  };

  const [allSubmitted, setAllSubmitted] = useState(false);

  const checkAllSubmitted = async () => {
    try {
      const response = await axiosInstance.get(
        `/schedules/check-submitted/${scheduleViewId}`
      );
      setAllSubmitted(response.data?.data === true);
    } catch (error) {
      console.error("Error checking submission status:", error);
    }
  };

  useEffect(() => {
    if (scheduleViewId) {
      checkAllSubmitted();
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);
  const [, setOtpEnable] = useState(false);

  const checkOtpEnable = async () => {
    try {
      const response = await axiosInstance.get(`/schedules/is-otp-enabled`);
      if (response.data?.status) {
        setOtpEnable(response.data.data === true);
      } else {
        setOtpEnable(false);
      }
    } catch (error) {
      setOtpEnable(false);
    }
  };

  useEffect(() => {
    checkOtpEnable();
  }, [scheduleViewId]);

  useEffect(() => {
    if (allForm?.signature1?.file) {
      setRemoveSignOne(allForm?.signature1?.file);
    }
    if (allForm?.signature2?.file) {
      setRemoveSignTwo(allForm?.signature2?.file);
    }
  }, [allForm]);

  const [loadingEditId, setLoadingEditId] = useState(null);

  const handleEditClick = async (id, user) => {
    try {
      setLoadingEditId(id);

      if (editModeIndex === id) {
        await CloseEditForm(id);
        setEditModeIndex(null); 
      } else {
        await OpenEditForm(id, user);
        setEditModeIndex(id); 
      }
    } finally {
      setLoadingEditId(null);
    }
  };

  const handleCloseEditMode = () => {
    setEditModeIndex(null);
  };

  // Find the current form being viewed
  const currentForm = forms.find(item => item.id === parseInt(scheduleViewId)) || form;

  return (
    <>
      <div className="py-4 px-4 overflow-hidden h-[calc(100vh-80px)] flex flex-col">
        <div className="sm:flex justify-between w-full mb-4">
          <Breadcrumb
            items={[
              {
                name: "Form",
                link: `/inspection/schedule/newform/${scheduleViewId}`,
              },
              {
                name: currentForm?.formName || "Form Details",
              },
            ]}
            onNavigate={handleNavigation}
          />
               
          <div className="flex gap-2 justify-end">
            {GetAccess("inspection_schedule_form_edit") && (GetRole() || isSubmittted) && (
              <span
                onClick={() => handleEditClick(scheduleViewId, currentForm?.workingUser)}
                className={`cursor-pointer mr-4 rounded-md p-1 border 
                  ${
                    editModeIndex === scheduleViewId
                      ? "bg-green-100 border-green-500"
                      : "bg-red-100 border-red-500"
                  }`}
              >
                {loadingEditId === scheduleViewId ? (
                  <div className="w-4 h-4 border-2 border-green-500 border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <EditIcon
                    color={editModeIndex === scheduleViewId ? "green" : "red"}
                    height={16}
                  />
                )}
              </span>
            )}
            <BackButton onClick={() => handleNavigation(-1)} />
          </div>
        </div>
        
        {currentForm && (
          <div className="h-auto rounded-lg p-2">
            <div className="md:flex gap-4 w-full">
              <div className="flex gap-3">
                <div className="flex items-start">
                  <div className="flex-shrink-0 font-medium text-xs">Schedule :</div>
                  <div className="text-[#606279] text-xs flex-1 mx-1">
                    {formatDateTime(currentForm.dateTime)}
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="flex-shrink-0 font-medium text-xs">Assigned To :</div>
                  <div className="text-[#606279] font-medium text-xs flex-1 mx-1">
                    {currentForm.assignees && currentForm.assignees.length > 0 
                      ? currentForm.assignees.map(a => a.assigneeName).join(", ") 
                      : 'Unassigned'
                    }
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="flex-shrink-0 font-medium text-xs">Updated by :</div>
                  <div className="text-[#606279] text-xs flex-1 mx-1">
                    {currentForm.updatedByName || 'None'}
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 font-medium text-xs">Last Updated :</div>
                  <div className="text-[#606279] font-medium text-xs flex-1 mx-1">
                    {currentForm.updatedOn ? formatDateTime(currentForm.updatedOn) : 'Never'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        
        <div className="bg-white flex-1 overflow-y-auto rounded-md">
          <form onSubmit={formik.handleSubmit}>
            <NewCommonDynamicForm
              formData={allForm?.titles || []}
              formik={formik}
              allValue={allValue}
              setAllValue={setAllValue}
              SaveFormData={editModeIndex === scheduleViewId ? SaveFormData : null}
              editModeIndex={editModeIndex === scheduleViewId}
              index={scheduleViewId}
              FileAttachment={setFileList}
              hasSign={false}
              hasSignOne={false}
              hasSignTwo={false}
              SignOne="Inspector"
              SignTwo="Client"
              setSignFunOne={setSignOne}
              setSignFunTwo={setSignTwo}
              allData={allForm}
              setFileRemoveList={setFileRemoveList}
              fileRemoveList={fileRemoveList}
              setRemoveSignOne={setRemoveSignOne}
              setRemoveSignTwo={setRemoveSignTwo}
              setAllForm={setAllForm}
            />
          </form>
        </div>

        {showNavigationConfirm && (
          <ModalContainer
            visiable={showNavigationConfirm}
            title="Form is Open"
            content={
              <div>
                <p>
                  The form is currently open for editing. Do you want to close
                  it before leaving?
                </p>
              </div>
            }
            handleClick={confirmNavigation}
            closeModal={cancelNavigation}
            isLoading={isClosingForm}
            confirmText="Yes, Close Form"
            cancelText="Cancel"
          />
        )}

        {showErrorFeild && (
          <ModalContainer
            closeModal={() => setShowErrorFeild(false)}
            visiable={showErrorFeild}
            title=""
            hasButton={false}
            content={
              <div className="max-w-[65vw] max-h-[90vh] min-h-[30vh] 2xl:min-w-[45vw]">
                <div className="w-full h-7 mb-2 flex justify-between items-center">
                  <p className="font-semibold text-sm">Fields to be checked</p>
                  <div className="flex gap-4 items-center">
                    <button
                      className="text-white bg-red-600"
                      onClick={() => {
                        setShowErrorFeild(false);
                        setErrorMessage("");
                      }}
                    >
                      <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="w-full max-h-[calc(90vh-32px)] overflow-y-auto">
                  <pre>{ErrorMessage}</pre>
                </div>
              </div>
            }
          />
        )}
      </div>
    </>
  );
}

export default FormOpen;